import { GridRowMutationAction, GridRowMutationResponse } from './mutate-grid-resource-row.model';

export enum MutateProductsRowRequestKeys {
  action = 'action',
  rowKey = 'rowKey',
  values = 'values',
}

export interface MutateProductsRowRequest {
  [MutateProductsRowRequestKeys.action]: GridRowMutationAction;
  [MutateProductsRowRequestKeys.rowKey]?: string | number | null;
  [MutateProductsRowRequestKeys.values]?: Record<string, unknown> | null;
}

export type MutateProductsRowResponse = GridRowMutationResponse;
